<template>
  <div class="tw-relative tw-mt-2" ref="element">
    <span class="tw-inline-block tw-w-full tw-rounded-md tw-shadow-sm">
      <div
        @click="toggleDropdown"
        aria-haspopup="listbox"
        aria-expanded="true"
        aria-labelledby="listbox-label"
        class="tw-focus:outline-none tw-focus:shadow-outline-blue tw-focus:border-blue-300 tw-sm:leading-5 tw-relative tw-w-full tw-cursor-pointer tw-rounded-md tw-border tw-border-gray-400 tw-bg-white tw-py-2 tw-pl-3 tw-pr-10 tw-text-left tw-text-sm tw-transition tw-duration-150 tw-ease-in-out"
      >
        <div class="tw-flex tw-items-center tw-space-x-3">
          <span class="tw-block tw-truncate tw-text-sm">
            {{ selectedItem.name }}
          </span>
        </div>
        <span class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-2">
          <font-awesome-icon v-if="isOpen" :icon="['fas', 'caret-up']" class="tw-text-gray-900" />
          <font-awesome-icon v-else :icon="['fas', 'caret-down']" class="tw-text-gray-900" />
        </span>
      </div>
    </span>

    <!-- Select popover, show/hide based on select state. -->
    <div
      v-show="isOpen"
      class="tw-absolute tw-z-50 tw-mt-1 tw-w-full tw-rounded-md tw-bg-white tw-pb-3.5 tw-shadow-2xl"
    >
      <ul
        tabindex="-1"
        role="listbox"
        aria-labelledby="listbox-label"
        aria-activedescendant="listbox-item-3"
        class="tw-shadow-xs tw-focus:outline-none tw-sm:text-sm tw-sm:leading-5 tw-max-h-56 tw-overflow-auto tw-rounded-md tw-py-1 tw-text-sm tw-leading-6"
      >
        <li
          v-bind:tabindex="index"
          @click="select(item.id)"
          @keydown.enter="select(item.id)"
          :id="`listbox-item-${index}`"
          role="option"
          v-for="(item, index) in items"
          :key="index"
          :class="{
            'hover:tw-bg-gray-50 focus:tw-bg-gray-50 focus:tw-outline-none': !isSelected(item.id),
          }"
          class="tw-relative tw-cursor-pointer tw-select-none tw-py-2 tw-pl-3 tw-pr-9 tw-text-gray-900"
        >
          <div class="tw-flex tw-items-center tw-space-x-3">
            <span
              class="tw-block"
              :style="[isSelected(item.id) ? { color: primaryColor } : null]"
              v-bind:class="{
                'tw-font-normal': !isSelected(item.id),
                'tw-font-bold': isSelected(item.id),
              }"
            >
              {{ item.name }}
            </span>
          </div>

          <!--
            Checkmark, only display for selected option.
          -->
          <span
            v-show="isSelected(item.id)"
            :style="{ color: primaryColor }"
            class="tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-4"
          >
            <font-awesome-icon :icon="['fas', 'check']" />
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({
  items: Array,
  modelValue: [null, Number],
  primaryColor: String,
});

let isOpen = ref(false);
const element = ref(null);

const emit = defineEmits(['update:modelValue']);

const selectedItem = computed(() =>
  props.modelValue ? props.items.find(item => item.id === props.modelValue) : { id: null, name: 'All' }
);

const isSelected = value => {
  return props.modelValue === value;
};

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const select = id => {
  isOpen.value = false;

  emit('update:modelValue', id);
};

const closeDropdown = e => {
  if (!element.value.contains(e.target)) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', closeDropdown);
});
</script>
